module.exports = __webpack_public_path__ + "img/astral-txt_5.0b24dcd0.svg";